import { Grid } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormTextField from '../../../../shared/FormTextField';
import ItineraryAddressFields from './ItineraryAddressFields';

const RestaurantForm = () => {
    const { control } = useFormContext();
    return (
        <Grid container item spacing={2}>
            <Grid item xs={12} sm={6}>
                {' '}
                <FormTextField
                    name='itineraryItemInfo.restaurantName'
                    control={control}
                    label='Restaurant Name'
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                {' '}
                <FormTextField
                    name='itineraryItemInfo.reservationName'
                    control={control}
                    label='Reservation Name'
                    placeholder='e.g. John Smith'
                />
            </Grid>

            <ItineraryAddressFields
                name='address'
                autocompletePlaceholder='Search address'
                title='Address (Optional)'
            />
        </Grid>
    );
};

export default RestaurantForm;
